import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import {
  isReturnsSettingsTab,
  LEGACY_SETTINGS_PATH_BY_TAB,
  legacySettingsPathForTab,
  RETURNS_SETTINGS_TAB_QUERY_PARAM,
  ReturnsSettingsTab,
} from "@redotech/redo-merchant-app-common/settings/returns-settings-tab";
import { useReturnsSettingsExperience } from "@redotech/redo-merchant-app-common/settings/use-returns-settings-experience";
import { useNavigate, useSearchParams } from "react-router-dom";

/** Switches to the old pages, landing on the one the current tab replaced. */
export function useSwitchToLegacySettings(): () => void {
  const routes = useRequiredContext(MerchantRoutesContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const experience = useReturnsSettingsExperience();

  return useHandler(() => {
    const tab = searchParams.get(RETURNS_SETTINGS_TAB_QUERY_PARAM);
    experience.switchToLegacy();
    const legacyPath =
      (isReturnsSettingsTab(tab) && legacySettingsPathForTab(tab)) ||
      LEGACY_SETTINGS_PATH_BY_TAB[ReturnsSettingsTab.COVERAGE];
    navigate(routes.getSettingsSubRoute(legacyPath));
  });
}
